import { getListing, GQLGetListingResponse, ListingCode } from 'graphql/listings/queries';
import { UseQueryOptions, useQuery } from 'react-query';

type Params = {
  code: ListingCode;
  queryConfig?: UseQueryOptions<GQLGetListingResponse, Error, GQLGetListingResponse, any>;
};

export const useGetListings = ({ code, queryConfig }: Params) =>
  useQuery([{ code }, 'interest-kind-listing'], () => getListing({ code }), {
    ...queryConfig,
    staleTime: Infinity,
    cacheTime: Infinity,
    refetchOnWindowFocus: false,
    enabled: !!code && queryConfig?.enabled !== false,
  });
